import React from 'react';
import en from '../../../../lang/en-us';
import enUs from '../../../../lang/en-us';
import { PurchaseDetailsBox } from './PurchaseDetailsBox';
import { BoxDataType } from '.';
import {
    getAddressType,
    getIncomeValue,
    getPepValue,
    getSourceOfWealth,
} from '../../portfolios/utils';
import { useDispatch } from 'react-redux';
import { UPDATE_PURCHASE_INFO } from '../../../../redux-store/types/newPurchase';
import {
    checkForOnlyAlphabets,
    getDateString,
    isFloatingNumber,
    isNumber,
} from '../../../../utils/constants';
import { ErrorSectionTypes } from '../ExploreMFs/types';
import { KYC_MIN_LENGHTHS, MAX_LENGTHS } from '../../makeNct/FatcaDeclaration/utils';

const { dbCommercial } = en;
const { dashboard } = enUs;
export default function KycDetailsPurchase(props: any) {
    const [kycDetailsBoxData, setKycDetails] = React.useState<BoxDataType[]>([]);
    const { apiData } = props;
    const dispatch = useDispatch();
    React.useEffect(() => {
        const firstHolderFatca = apiData.fatcaDetails.find((fatca: any) => fatca.fatcaId === 'FH');
        setKycDetails([
            {
                label: dashboard.FatcaDeclaration.kycFields.fatherName,
                value: firstHolderFatca.fatherName,
                isEditable: true,
                apiKey: 'fatherName',
                name: 'father-name',
                validate: (value: string) =>
                    checkForOnlyAlphabets(value) && value.length <= MAX_LENGTHS.fatherName,
                errors: (value: string) => !!value && value.length < KYC_MIN_LENGHTHS.fatherName,
                getHelperText: (value: string) => 'Please enter minimum 2 characters',
            },
            {
                label: dashboard.FatcaDeclaration.kycFields.spouseName,
                value: firstHolderFatca.spouseName,
                isEditable: true,
                apiKey: 'spouseName',
                name: 'spouse-name',
                validate: (value: string) =>
                    checkForOnlyAlphabets(value) && value.length <= MAX_LENGTHS.spouseName,
                errors: (value: string) => !!value && value.length < KYC_MIN_LENGHTHS.spouseName,
                getHelperText: (value: string) => 'Please enter minimum 2 characters',
            },
            {
                label: dashboard.FatcaDeclaration.kycFields.pepFlag,
                value: firstHolderFatca.pepFlag,
                isEditable: true,
                dropDown: true,
                dropDownValues: Object.keys(getPepValue),
                helperObjectForValues: getPepValue,
                apiKey: 'pepFlag',
                name: 'pep-flag',
            },
            {
                label: dashboard.FatcaDeclaration.kycFields.sourceOfWealth,
                value: firstHolderFatca.sourceOfWealth,
                isEditable: true,
                dropDown: true,
                dropDownValues: Object.keys(getSourceOfWealth),
                helperObjectForValues: getSourceOfWealth,
                apiKey: 'sourceOfWealth',
                name: 'source-of-wealth',
            },
            {
                label: dashboard.FatcaDeclaration.kycFields.addressType,
                value: firstHolderFatca.addressType,
                isEditable: true,
                dropDown: true,
                dropDownValues: Object.keys(getAddressType),
                helperObjectForValues: getAddressType,
                apiKey: 'addressType',
                name: 'address-type',
            },
            {
                label: dashboard.FatcaDeclaration.kycFields.netWorthDate,
                value: firstHolderFatca.netWorthDate,
                datePicker: true,
                isEditable: true,
                apiKey: 'netWorthDate',
                name: 'Date',
            },
            {
                label: dashboard.FatcaDeclaration.kycFields.annualIncomeSlab,
                value: firstHolderFatca.annualIncomeSlab,
                isEditable: true,
                dropDown: true,
                dropDownValues: Object.keys(getIncomeValue) || [],
                helperObjectForValues: getIncomeValue,
                apiKey: 'annualIncomeSlab',
                name: 'annual-income-slab',
            },
            {
                label: dashboard.FatcaDeclaration.kycFields.netWorth,
                value: firstHolderFatca.netWorth,
                isEditable: true,
                isNumber: true,
                apiKey: 'netWorth',
                name: 'net-worth',
                validate: (value: string) =>
                    isNumber(value) && value.length <= MAX_LENGTHS.netWorth,
                errors: (value: string) => !!value && Number(value) <= 0,
                getHelperText: (value: string) => 'Amount should be greater than zero',
            },
        ]);
    }, []);

    const submitCallBack = () => {
        const fh_index = apiData.fatcaDetails.findIndex((fatca: any) => fatca.fatcaId === 'FH');
        const updateApiData = apiData.fatcaDetails[fh_index];
        kycDetailsBoxData.forEach((kycData: any) => {
            if (kycData.apiKey === 'netWorthDate') {
                updateApiData[kycData.apiKey] = getDateString(kycData.value);
            } else {
                updateApiData[kycData.apiKey] = kycData.value;
            }
        });
        console.log(updateApiData);
        apiData.fatcaDetails[fh_index] = updateApiData;
        dispatch({
            type: UPDATE_PURCHASE_INFO,
            body: apiData,
        });
        if (!!props.resetError && typeof props.resetError === 'function') {
            props.resetError();
        }
    };
    return (
        <PurchaseDetailsBox
            onChange={setKycDetails}
            boxDetails={kycDetailsBoxData}
            heading={dbCommercial.newPurchase.leftMenu.kyc}
            submitCallBack={submitCallBack}
            errorSection={
                props.errorSection?.section === ErrorSectionTypes.KycDetails
                    ? props.errorSection
                    : null
            }
        />
    );
}
